import styled from 'styled-components';
import { useState } from 'react';
import Image from 'next/legacy/image';
import ImageModal from './image-modal';
import Icon from './icon';

export type ImageWithZoomProps = {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
};

export const ImageWithZoom: React.FC<ImageWithZoomProps> = ({ src, alt, width, height }) => {
  const [zoom, setZoom] = useState(false);

  return (
    <StyledImageWithZoom>
      {zoom && (
        <ImageModal open={zoom} src={src} alt={alt} width={width} height={height} onClose={() => setZoom(false)} />
      )}
      <div
        className="image-button"
        role="button"
        tabIndex={0}
        onClick={() => setZoom(true)}
        onKeyDown={() => setZoom(true)}
      >
        <Image
          src={`${src.startsWith('//') ? `https:${src}` : src}`}
          alt={alt || ''}
          width={width}
          height={height}
          layout="intrinsic"
          quality={100}
        />
        <div className="zoom-hover">
          <Icon name="inspect" />
        </div>
      </div>
    </StyledImageWithZoom>
  );
};

export const StyledImageWithZoom = styled.div`
  .image-button {
    position: relative;
    margin: 1rem 0;
    cursor: zoom-in;

    > span {
      box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.05), 0 1px 1px rgba(0, 0, 0, 0.05), 0 2px 2px rgba(0, 0, 0, 0.05),
        0 4px 4px rgba(0, 0, 0, 0.05), 0 8px 8px rgba(0, 0, 0, 0.05);
    }

    .zoom-hover {
      align-items: center;
      border-radius: 50%;
      bottom: 20px;
      background-color: var(--secondary-box-shadow);
      color: var(--text-subtle);
      display: flex;
      font-size: 20px;
      height: 40px;
      justify-content: center;
      position: absolute;
      right: 10px;
      text-decoration: none !important;
      width: 40px;
    }

    &:hover {
      .zoom-hover {
        background-color: var(--body-background);
        color: var(--text);
      }
    }
  }
`;

export default ImageWithZoom;
